import { ConfigurationType } from '../../../api/candidate/config/model';
import { WithdrawalReason } from '../../../api/candidate/exam/model';
import { MenuItems } from '../../../components/select/model';

export const dropDownData = (data: any) => {
  if (!data) {
    return [];
  }
  return data.map((option: any) => ({
    children: option,
    value: option,
    key: `k-${option}`,
  }));
};

export const configurationTypeData = (data: ConfigurationType[]) => {
  if (!data) {
    return [];
  }
  return data.map((option) => ({
    children: option.description,
    value: option.code,
    key: `k-${option.code}`,
  }));
};

export const withdrawalTypeData = (data: WithdrawalReason[]) => {
  if (!data) {
    return [];
  }
  const list: MenuItems[] = [];

  data.forEach((option) =>
    list.push({
      children: option.reasonDescription,
      value: option.reasonDescription,
      key: `k-${option.reasonUuid}`,
    })
  );

  return list;
};
